import styled from '@emotion/styled';
import { moreActions } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { MoreIcon } from 'src/assets/new-icon/MoreIcon';
import { fadeIn } from '../animation/AnimationAndTransition.style';

export const MoreActionsWrapper = styled('div', { label: 'MoreActionsWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-end;
    margin-left: 12px;
`;

export const MoreIconButton = styled('button', { label: 'MoreIconButton' })`
    background: none;
    border: none;
    cursor: pointer;
    height: 24px;
    width: 24px;
    padding: 0;
`;

interface MoreIconPropsType {
    subsection?: 'one' | 'two';
}

export const MoreIconWrapper = styled(MoreIcon, { label: 'MoreIconWrapper' })<MoreIconPropsType>`
    height: 24px;
    width: 24px;
    stroke: ${({ subsection }): string => subsection === 'one' ? moreActions.bgColorQuaternary : subsection === 'two' ?  moreActions.bgColorQuaternary : moreActions.bgColorTertiary};
`;

interface ActionsDropdownWrapperPropsType {
    height: string;
    inset: string | undefined;
}

export const ActionsDropdownWrapper = styled('div', { label: 'ActionsDropdownWrapper' })<ActionsDropdownWrapperPropsType>`
    position: fixed;
    width: 104px;
    height: ${({ height }): string => `${height}px`};
    ${({ inset }): string => inset === undefined ? '' : `inset: ${inset}`};
    box-shadow: 0px 2px 13px -4px rgba(0, 0, 0, 0.5);
    z-index: 1;
    animation: 0.3s ease ${fadeIn} forwards;
`;

export const Action = styled('div', { label: 'Action' })`
    background-color: ${moreActions.bgColor};
    color: ${moreActions.txtColor};
    cursor: pointer;
    height: 32px;
    font-weight: ${fontWeight.medium};
    font-size: ${fontSize.small};
    line-height: 1.33;
    padding: 8px 12px;

    &:hover {
        background-color: ${moreActions.bgColorSecondary};
    }
`;
